import type { WithActiveBranchId } from '@app/api/shared';

export enum ClientFilesEndpoints {
  GetClientFile = 'GetClientFile',
  GetClientFileList = 'GetClientFileList',
  AddClientFile = 'AddClientFile',
  AddClientFiles = 'AddClientFiles',
  DeleteClientFile = 'DeleteClientFile',
  DeleteClientFiles = 'DeleteClientFiles',
  Download = 'Download',
  Stream = 'Stream',
}

export interface ModelClientFile {
  Id: number;
  TimeCreated: string;
  ClientId: number;
  Description: string | null;
  FileName: string | null;
  FileSize: number;
  Data: string | null;
  Extension: string | null;
  Thumbnail: string | null;
  ClientMessageId: number | null;
}

export type GetClientFileRequest = WithActiveBranchId<{
  fileId: number;
}>;

export type GetClientFileListRequest = WithActiveBranchId<{
  clientId: number;
}>;

export type AddClientFileRequest = WithActiveBranchId<{
  data: ModelClientFile;
}>;

export type AddClientFilesRequest = WithActiveBranchId<{
  data: ModelClientFile[];
}>;

export type DeleteClientFileRequest = WithActiveBranchId<{
  fileId: number;
}>;

export type DeleteClientFilesRequest = WithActiveBranchId<{
  data: number[];
}>;

export type DownloadClientFileRequest = WithActiveBranchId<{
  clientId: number;
  fileId: number;
}>;

export type StreamClientFileRequest = WithActiveBranchId<{
  databaseId: string;
  clientId: number;
  fileExternalId: string;
}>;

export type GetClientFileResponse = ModelClientFile;
export type GetClientFileListResponse = ModelClientFile[];
export type AddClientFileResponse = ModelClientFile;
export type AddClientFilesResponse = ModelClientFile[];
export type DeleteClientFileResponse = void;
export type DeleteClientFilesResponse = void;
export type DownloadClientFileResponse = ArrayBuffer;
export type StreamClientFileResponse = ArrayBuffer;
